import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import Card from '../../Fuse/Card';
import ContentRulesActionStore from '../../../stores/Policy/ContentRules/ContentRulesActionStore';
import FuseReadOnlyRadioButton from '../../FuseControls/FuseReadOnlyRadioButton';
import './ContentRulesAction.css';

const block = b.lock('ContentRulesAction');

class ContentRulesAction extends Component {
    static propTypes = {
        store: ContentRulesActionStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    render() {
        const { store, readOnly } = this.props;

        return <Card title="Action" className={block()} >
            <div className={block('RowContainer')}>
                <FuseReadOnlyRadioButton
                    value
                    readOnly={readOnly}
                    className={block('RadioButton')}
                    store={store.action}
                    label={'Allow - show the page contents'}
                    qa={'allow-radio'}
                />
                <FuseReadOnlyRadioButton
                    value={false}
                    readOnly={readOnly}
                    className={block('RadioButton')}
                    store={store.action}
                    label={'Block - display a content blocked page'}
                    qa={'block-radio'}
                />
            </div>
        </Card>;
    }
}

export default observer(ContentRulesAction);
